import { windowMedia } from "../helpers";

export class stickybar
{
    public initialized: boolean = false;
    private containerID: string = "w-sticky-bar";
    private container: HTMLElement;
    private mobileOnly: boolean;

    constructor(content: HTMLElement, mobileOnly: boolean = true)
    {
        this.mobileOnly = mobileOnly;
        if (this.mobileOnly && !windowMedia(768))
            return;

        document.getElementById(this.containerID)?.remove();

        const container = document.createElement("div");
        container.id = this.containerID;
        container.className = "w-sticky-bar";

        if (content)
            container.appendChild(content);

        document.body.appendChild(container);
        this.container = container;

        this.initObserver();
        this.initialized = true;
    }

    public updateContent(content: HTMLElement)
    {
        this.container.innerHTML = "";
        this.container.appendChild(content);
    }

    private initObserver()
    {
        const stickyHeight = this.container.clientHeight;
        document.body.style.paddingBottom = stickyHeight + "px";
        document.body.classList.add("has-sticky");
    }
}